<template>
  <!-- Como pasamos los datos mediante un v-bind, se añaden los parámetros al html directamente como
  si fuesen parámetros html. El título es el único que muerde (añade tooltips con el título en todos lados)
  así que lo quitamos -->
  <div :title="undefined" class="nx-scrollytelling-slide-editor-form">
    <nx-scrollytelling-slide-title :title="slideTitle" />
    <template v-if="formComponent">
      <!-- Como pasamos los datos mediante un v-bind, se añaden los parámetros al html directamente como
      si fuesen parámetros html. El título es el único que muerde (añade tooltips con el título en todos lados)
      así que lo quitamos -->
      <component :is="formComponent"
                 :title="undefined"
                 ref="form"
                 :value="value"
                 :scope="value.uuid"
                 v-on="$listeners"
                 v-bind="$attrs"
      />
    </template>
    <template v-else>
      <v-flex xs12 class="d-inline-flex align-center">
        <v-icon large color="error">warning</v-icon>
        <h3 class="title ml-3">No form component found for type <code>{{ type }}</code></h3>
      </v-flex>
    </template>
  </div>
</template>

<script>
import { availableSlideTypes } from '@/modules/scrollytelling/config';
import NxScrollytellingSlideTitle from '@/modules/scrollytelling/components/form/components/ScrollytellingSlideTitle';

export default {
  name: 'nx-scrollytelling-slide-editor-form',
  components: { NxScrollytellingSlideTitle },
  props: {
    uuid: {
      type: String,
    },
    name: {
      type: String,
    },
    type: {
      type: String,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    slideTitle() {
      return this.value.name || this.$t(`message.content.editor.scrollytelling.type.${this.type}`);
    },
    formComponent() {
      const config = availableSlideTypes.find(slide => slide.type === this.type);
      if (!config) {
        return null;
      }
      return config.formComponent;
    },
  },
};
</script>

<style lang="stylus" scoped>
.nx-scrollytelling-slide-editor-form {
  padding-top: 16px
}
</style>
